import styled from 'styled-components';
import { TextField as Input } from '.';

export const TextField = styled(Input)`
  width: 100%;
  height: 56px;
  margin-bottom: 19px;
`;